import { ReactComponent as LoaderIcon } from '../../../icons/loader.svg';

import './button.scss';

export const Button = ({
  outline,
  children,
  className = '',
  onClick,
  type,
  style,
  secondary,
  tertiary,
  loading,
  disabled = false,
  small = false,
  large = false
}) => {
  return (
    <button
      type={type}
      onClick={disabled ? () => {} : onClick}
      disabled={disabled}
      style={style}
      className={`button
      ${secondary ? 'button--secondary' : ''}
      ${tertiary ? 'button--tertiary' : ''}
      ${outline ? 'button--outline' : ''}
      ${disabled ? 'button--disabled' : ''}
      ${small ? 'button--small' : ''}
      ${large ? 'button--large' : ''}
      ${className}`}
    >
      {loading ? <LoaderIcon width={24} height={24} /> : children}
    </button>
  );
};
